<template>
  <v-card class="ma-5 mx-auto" :flat="this.$vuetify.breakpoint.mobile" >
<!--    <v-btn color="gray" small icon right absolute @click.native="$router.push('/leaderboard')">-->
<!--      <v-icon small>mdi-fullscreen</v-icon>-->
<!--    </v-btn>-->
    <v-card-title v-if="!seasons || seasons.length === 1">Global Leaderboard</v-card-title>
    <v-card-title v-else>
      <v-select class="card-title" v-if="seasons != null" v-model="selectedSeason" :items="seasons" @change="updateLeaderboardBySelectedSeason"
                item-text="name" item-value="id" :hint="getSeasonDescription" return-object single-line persistent-hint></v-select>
    </v-card-title>
    <v-simple-table dense>
      <template v-slot:default>
        <thead>
        <tr>
          <th class="text-left">Rank</th>
          <th class="text-left">Username</th>
          <th class="text-left">Points</th>
          <th class="text-left"></th>
        </tr>
        </thead>
        <tbody>
        <tr v-for="item in leaderboardData" :key="item.id" >
          <td>{{ item.rank }}</td>
          <td>{{ item.username }}</td>
          <td>{{ item.racePoints }}</td>
          <td>
            <div style="margin: -5px;">
              <country-flag v-if="item.country" :country="item.country"/>
            </div>
          </td>
        </tr>
        </tbody>
      </template>
    </v-simple-table>
    <v-card-actions v-if="!showAllInitial">
      <v-btn text color="teal accent-4" v-if="!showAll" @click="showAll = !showAll">Show More</v-btn>
      <v-btn text color="teal accent-4" v-if="showAll" @click="showAll = !showAll">Show Less</v-btn>
      <v-spacer></v-spacer>
      <v-btn icon @click="showAll = !showAll">
        <v-icon>{{ showAll ? 'mdi-chevron-up' : 'mdi-chevron-down' }}</v-icon>
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>

import _ from 'lodash';
import {eSailServerPublic} from "@/plugins/axios";

export default {
  name: "LeaderboardCard",
  data: () => ({
    showAll: false,
    seasons: null,
    selectedSeason: null,
    leaderboard: null,
    leaderboardTop3: null
  }),
  props: {
    showAllInitial: Boolean
  },
  computed: {
    leaderboardData() {
      return this.showAll ? this.leaderboard : this.leaderboardTop3
    },
    getSeasonDescription() {
      if (!this.selectedSeason || this.selectedSeason.id === 0) {
        return null
      } else {
        return this.selectedSeason.description + (this.selectedSeason.endsInDays > 0 ? " (ends in " + this.selectedSeason.endsInDays + " days)" : "")
      }
    }
  },
  mounted() {
    eSailServerPublic.get('info/game/seasons')
        .then(response => {
          this.seasons = response.data
          this.seasons.push({ name: "Global Leaderboard", description: "", id: 0 })
          let activeSeasons = _(this.seasons).filter(item => item.endsInDays > 0).orderBy('endsInDays', 'asc').value()
          this.selectedSeason = activeSeasons.length > 0 ? activeSeasons[0] : this.seasons[this.seasons.length-1]
          this.updateLeaderboardBySelectedSeason()
        })
    this.showAll = this.showAllInitial
  },
  methods: {
    updateLeaderboardBySelectedSeason() {
      if (!this.selectedSeason) return
      if (this.selectedSeason.id === 0) {
        eSailServerPublic.get('info/game/users/global-leaderboard')
            .then(response => {
              this.leaderboard = response.data
              let rank = 1
              this.leaderboard.forEach(item => item.rank = rank++)
              this.leaderboardTop3 = _.slice(this.leaderboard, 0, 3)
            })
      } else {
        eSailServerPublic.get('info/game/seasons/' + this.selectedSeason.id + '/leaderboard')
            .then(response => {
              const resp = response.data
              _.each(resp, item => item.user.racePoints = item.points)
              this.leaderboard = _.map(resp, item => item.user)
              let rank = 1
              this.leaderboard.forEach(item => item.rank = rank++)
              this.leaderboardTop3 = _.slice(this.leaderboard, 0, 3)
            })
      }
    }
  }
}
</script>

<style scoped>
.card-title{
  font-size: 20px;
}
</style>